export default function verified({ next, store }) {
    if (store.getters["auth/authUser"] && store.getters["auth/isVerified"]) next();
    else if (store.getters["auth/authUser"] && !store.getters["auth/isVerified"]) next({ name: "VerifyEmail" });
    else next({ name: "Login" });
  }